/* * @Author: 孙福聪 * @Date: 2019-01-22 10:32:30 * @Last Modified by: mikey.zhaopeng * @Last
Modified time: 2019-02-14 17:20:06 */
<template lang="pug">
div.case-index-t
  .title 我的案例
  Button.btnbild(type="primary",v-if="enableAI", @click="showAIDialog",style='margin-top: 10px;') AI生成
  Modal(v-model="aiDialogVisible" title="AI案例生成" @on-ok="generateCase")
    Form(:model="aiForm" :label-width="80")
      FormItem(label="政策信息")
        Input(v-model="aiForm.name" placeholder="请输入政策信息")

  ul.case-list
    li.add-case(@click="add_case",v-if="pageNo === 1")
      img(src='../../../assets/case/addCase.png')
      span 添加案例
    li(v-for='item in caseList' :title='item.caseName').list
      img(:src='item.caseCover')
      //- div.hover
      //-   div.icon
      //-     div.create(@click='gotoCase(item)')
      //-       Icon(type="md-create")
      //-     div.trash(@click='delCase(item)')
      //-       Icon(type="md-trash")
      div.teach-case-content-t
        div.case-title {{item.caseName}}
        ul.label-ul
          li.Label(v-for='(v,idx) in item.caseTypes',v-if='idx<=2') {{v}}
        div.Horizontal-line
        p.time.circle(:style="!item.publish?'background:rgba(207,207,207,1)':''")
        p.time.publish {{item.publish?'已发布':'未发布'}}
        p.time {{item.turnoverTime}}
        p.type  {{item.auditStatus}}
        div.menu
          img.menu(src="../../../assets/case/menu2.png")
          ul.edit-menu
            li(@click='gotoCase(item)').Label 编辑
            li(@click='gotoCase(item,true)').Label 查看
            li(@click='copyCase(item)').Label-1 复制
            li(@click='sharecase(item)').Label-2 分享
            li(@click='delCase(item)').Label-3 删除
  Page.page(@on-change="handleCurrentChange" :total="pageData.totalRecords%10 === 0 ? pageData.totalRecords+1 : pageData.totalRecords",
         :page-size="10" :current="pageData.pageNo" show-elevator show-total)
         span 当前有{{caseList.length}}条数据，共{{pageData.totalRecords}}条数据
  Modal(v-model="modal1" title="复制案例" width="520px" @on-ok="cloneCase")
    Form(:label-width="80")
      FormItem(label="案例标题")
        Input(v-model="copyTitle",:maxlength="25")
  Modal(v-model="modal2" title="共享案例" width="520px" @on-ok="share()").shareForTeacher
    div.addTeacherstitle 选择用户:
    iSelectSearch(
      ref='iSelectSearch'
      :optionList='teacherlist',
      @change='selectChange'
      @inputChange='searchChange'
      )
    //- // 既然没这功能咱们就自己造一个嘛
    //- div.addTeachers
    //-   // 这里是外框的上半部分
    //-   div.inputBlock(@click="addTeachers = !addTeachers")
    //-     div.tagBox
    //-       // 最后一步,贴tag
    //-       div
    //-         //- span.noSelect(v-if="teacherSelect.length === 0") 请选择
    //-         Tag.selectSearchTag(v-for="(item, index) in teacherSelect" closable :key="index" @on-close="delSelect(index)") {{teacherSelectName[index]}}
    //-         input.selectSearch(
    //-           :style='{width:getInputWidths}'
    //-           v-model='selectInput'
    //-           ref='selectSearch'
    //-           placeholder='请选择'
    //-           )
    //-     Icon.openDown(:type="addTeachers === true?'ios-arrow-up':'ios-arrow-down'" )
    //-   // 这里是点开的部分
    //-   div.teachersList(v-if="addTeachers === true")
    //-     ul.dropDownList
    //-       li.listChild(@click="allIn()" v-if='teacherlist.length !== 0' style="border-bottom:1px solid #F3F3F4")
    //-         span.ListName(:class="allInCheck === true? 'checkThisTeacher':''") 全选
    //-         Icon.current(:class="allInCheck === true? 'checkThisTeacher':''" type="md-checkmark")
    //-       li.listChild(v-if='teacherlist.length === 0' style="border-bottom:1px solid #F3F3F4")
    //-         span.ListName(:class="allInCheck === true? 'checkThisTeacher':''") 暂无数据
    //-       li.listChild(v-for="item in teacherlist" @click="chooseShareTeacher(item)" v-if="item.code !== $role.code")
    //-         span.ListName(:class="teacherSelect.indexOf(item.code) === -1 ? '' : 'checkThisTeacher' ") {{item.name}}
    //-         Icon.current(:class="teacherSelect.indexOf(item.code) === -1 ? '' : 'checkThisTeacher' " type="md-checkmark")
    //- div.mask(v-show="addTeachers === true" @click="closeInput()")
</template>

<script>
import iSelectSearch from "@/components/common/iSelectSearch.vue"; /** 自定义下拉框 */

export default {
  components: {
    iSelectSearch
  },
  computed: {
    /** 更新input的宽度 */
    getInputWidth() {
      const { teacherSelect } = this;
      return (refName = "selectSearch", tagName = "selectSearchTag") => {
        /** 有tag，返回处理后的宽度 */
        if (teacherSelect.length) {
          const currentNode = this.$refs[refName];
          if (currentNode) {
            const parentNode = currentNode.parentNode;
            // console.log(currentNode, "refName", parentNode);

            if (parentNode) {
              // console.log(parentNode.clientWidth, "clientWidth selectSearchTag ");
              let w = 0;
              let r = "";
              this.$nextTick(() => {
                const nodeList = document.querySelectorAll(`.${tagName}`);
                Array.from(nodeList).forEach(ele => {
                  // console.log(ele.clientWidth, "eeeee");
                  w += ele.clientWidth;
                  w += 4; // 边距4px
                });
                // w %= parentNode.clientWidth;
                console.log(w, "tag", parentNode.clientWidth, "width");
                if (parentNode.clientWidth <= w + 30) {
                  console.log("改换行了");
                  r = "100%";
                  return "100%";
                }
                r = `${parentNode.clientWidth - w}px`;
                return `${parentNode.clientWidth - w}px`;
              });
              console.log(r, "r");
              return r;
            }
          }

          // const iWidth = 80; // 假设一个tag是80px
          // const resWidth = teacherSelect.length * iWidth;
          // if (resWidth >= 450) return "100%";

          // return `calc(100% - ${resWidth}px)`;
        }
        /** 如果没有tag，返回100% */
        return "100%";
      };
    }
  },
  data() {
    return {
      teacherSelect: [],
      teacherSelectName: [],
      teacherlist: [],
      caseList: [],
      modal1: false,
      singleCase: {},
      copyTitle: "",
      modal2: false,
      pageData: {},
      pageNo: 1,
      addTeachers: false,
      allInCheck: false,
      aiDialogVisible: false,
      aiForm: {
      },
      enableAI: false
    };
  },
  created() {
    this.query();
    this.getTeacherlist();
  },
  watch: {
    modal2: {
      handler(newVal) {
        if (newVal === false) {
          // this.addTeachers = false;
          // this.teacherSelect = [];
          // this.teacherSelectName = [];
          this.$refs.iSelectSearch.initValue();
        }
      }
    }
  },
  mounted() {
    this.checkEnableAI();
  },
  methods: {
    checkEnableAI() {
      this.$http.getEnableState().then(res => {
        if (res.data.success) {
          this.enableAI = res.data.data;
        } else {
          this.enableAI = false;
        }
      }).catch(() => {
        this.enableAI = false;
      });
    },
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { name: "" };
    },
    generateCase() {
      if (!this.aiForm.name) {
        this.$Message.error("请输入政策信息");
        return;
      }
      const data = {
        inputs: {
          opt_type: "gen_case",
          gen_case_policy_info: this.aiForm.name,
          userId: this.$role.code
        }
      };

      this.$http.generateCase(data).then(res => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          this.query();
        }
      });
    },
    /** iSelectSearch组件 */
    selectChange(childData) {
      this.teacherSelect = childData.selectKeys;
      this.teacherSelectName = childData.selectNames;
    },
    /** iSelectSearch组件 */
    searchChange(childData) {
      this.getTeacherlist({ name: childData || "" });
    },
    /**  */
    handleCurrentChange(page) {
      this.query(page);
    },
    getTeacherlist(params = {}) {
      // 获取教师列表 listUser getUserList
      // console.log(params, "params");
      const data = { queryParam: { ...params, role: 1 }, pageNo: 1, pageSize: 9999 };
      this.$http.getUserList(data).then(res => {
        if (res.data.success) {
          this.teacherlist = res.data.data.list;
        }
      });
      // this.$http.listUser({}).then(res => {
      //   if (res.data.success) {
      //     this.teacherlist = res.data.data.list;
      //   }
      // });
    },
    cloneCase() {
      // 克隆案例
      console.log(this.singleCase);
      const data = {
        pyId: this.singleCase.id,
        name: this.copyTitle
      };
      this.$http.copyCaseExperiment(data).then(res => {
        if (res.data.success) {
          this.$Message.success("复制案例成功");
          this.query();
        }
      });
    },
    copyCase(value) {
      this.modal1 = true;
      this.singleCase = value;
      this.copyTitle = value.caseName.concat("的副本");
      const maxNum = this.copyTitle.length - 25;
      if (maxNum > 0) {
        this.copyTitle = this.copyTitle.slice(0, 25);
      }
    },
    share() {
      const data = {
        pyId: this.singleCase.id,
        userIds: JSON.stringify(this.teacherSelect)
      };
      if (this.teacherSelect.length) {
        this.$http.shareCaseExperiment(data).then(res => {
          if (res.data.success) {
            this.$Message.success("分享成功");
            this.teacherSelect = [];
            this.teacherSelectName = [];
          } else {
            this.teacherSelect = [];
            this.teacherSelectName = [];
          }
        });
      }
    },
    sharecase(value) {
      if (!value.publish) {
        return this.$Message.warning("案例发布后可分享！");
      }
      this.$refs.iSelectSearch.selectInput = "";
      this.modal2 = true;
      this.singleCase = value;
    },
    delCase(value) {
      console.log(value);
      this.$Modal.confirm({
        title: "删除",
        content: "<p>是否删除该案例?</p>",
        onOk: () => {
          this.$http.batchDeletingCaseExperiment({ ids: `[${value.id}]` }).then(res => {
            if (res.data.success) {
              if (res.data.data) {
                this.$Message.success("删除成功!");
                this.query();
              } else {
                this.$Message.error("此案例有正在进行的实训,不能删除!");
              }
            }
          });
        }
      });
    },
    add_case() {
      const item1 = {
        CaseBrief: "",
        title: "", // 自定义案例的标题
        type: [], // 自定义案例的类型
        file: "", // 上传的图片
        id: "", // 案例的Id
        src: "",
        stem: "" // 案例的分析内容
      };
      sessionStorage.removeItem("CaseStage");
      sessionStorage.removeItem("SeeState");
      this.$store.commit("postCaseContent", item1);
      this.$store.commit("getCaseData", this.singleCase.id);
      this.$store.commit("getDoCaseData", this.singleCase.id);
      this.$router.push("/case");
    },
    /** 编辑and查看案例
     * state 为true时是查看 否则为编辑
     */
    gotoCase(item, state) {
      // 跳转案例页面
      if (item.underway && !state) {
        this.$Message.warning("该案例正在实训中不可编辑");
        return;
      }
      if (item.userId !== this.$role.code && !state) {
        return this.$Message.info("不能修改其他人的案例");
      }
      const item1 = {
        title: item.caseName,
        CaseBrief: item.caseDescription,
        type: item.caseTypes,
        file: "",
        src: item.caseCover,
        id: item.id,
        stem: item.editorOption
      };
      sessionStorage.setItem("SeeState", !!state);
      sessionStorage.removeItem("CaseStage");
      this.$store.commit("getCaseData", this.singleCase.id);
      this.$store.commit("getDoCaseData", this.singleCase.id);
      this.$store.commit("postCaseContent", item1);
      this.$router.push("/case");
    },
    query(page = 1) {
      const data = {
        userId: this.$role.code,
        pageNo: page,
        pageSize: page === 1 ? 9 : 10
      };
      this.$http.listCaseExperimentRequest(data).then(res => {
        this.pageNo = res.data.data.pageNo;
        this.pageData = res.data.data;
        function formatDate(dateL) {
          const now = new Date(dateL);

          const month = now.getMonth() + 1;

          let date = now.getDate();
          if (date < 10) {
            date = `0${date}`;
          }
          let hour = now.getHours();
          if (hour < 10) {
            hour = `0${hour}`;
          }
          let minute = now.getMinutes();
          if (minute < 10) {
            minute = `0${minute}`;
          }
          return `${month}-${date} ${hour}:${minute}`;
        }
        this.caseList = res.data.data.list.map(res1 => {
          if (this.$role.role === "admin" || this.$role.role === "teacher") {
            return {
              caseCover: res1.caseCover,
              caseDescription: res1.caseDescription,
              caseName: res1.caseName,
              caseTypes: JSON.parse(res1.caseTypes),
              disable: res1.disable,
              editorOption: res1.editorOption,
              id: res1.id,
              underway: res1.underway,
              turnoverTime: formatDate(Date.parse(new Date(res1.turnoverTime))),
              userId: res1.userId,
              userName: res1.userName,
              publish: res1.publish
            };
          }
          return {
            auditStatus: res1.auditStatus,
            caseCover: res1.caseCover,
            caseDescription: res1.caseDescription,
            caseName: res1.caseName,
            caseTypes: JSON.parse(res1.caseTypes),
            publish: res1.publish,
            disable: res1.disable,
            id: res1.id,
            underway: res1.underway,
            turnoverTime: formatDate(Date.parse(new Date(res1.turnoverTime))),
            userId: res1.userId,
            userName: res1.userName
          };
        });
      });
    }
    // // 点击选择分享教师
    // chooseShareTeacher(item) {
    //   if (this.teacherSelect.indexOf(item.code) === -1) {
    //     this.teacherSelect.push(item.code);
    //     this.teacherSelectName.push(item.name);
    //     if (this.teacherSelect.length === this.teacherlist.length - 1) {
    //       this.allInCheck = true;
    //     }
    //   } else {
    //     this.teacherSelect.splice(this.teacherSelect.indexOf(item.code), 1);
    //     this.teacherSelectName.splice(this.teacherSelect.indexOf(item.code), 1);
    //     this.allInCheck = false;
    //   }
    // },
    // // 全选
    // allIn() {
    //   this.teacherSelect = [];
    //   this.teacherSelectName = [];
    //   this.allInCheck = !this.allInCheck;
    //   if (this.allInCheck === true) {
    //     this.teacherlist.forEach(res => {
    //       if (res.code !== this.$role.code) {
    //         this.teacherSelect.push(res.code);
    //         this.teacherSelectName.push(res.name);
    //       }
    //     });
    //   } else {
    //     this.teacherSelect = [];
    //     this.teacherSelectName = [];
    //   }
    // },
    // // 删除tag
    // delSelect(index) {
    //   this.teacherSelect.splice(index, 1);
    //   this.teacherSelectName.splice(index, 1);
    //   this.allInCheck = false;
    // },
    // // 关闭选择框
    // closeInput() {
    //   this.addTeachers = false;
    // }
  }
};
</script>

<style lang="stylus">
.case-index-t
  position relative
  text-align left
  .page
    float right
    margin-top 10px
  .title
    font-size 24px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 1)
    line-height 30px
  .case-list
    margin-top 48px
    padding-bottom 32px
    display grid
    grid-template-columns 210px 210px 210px 210px 210px
    grid-column-gap 16px
    .list
      width 210px
      height 253px
      background #fff
      margin 7px
      vertical-align top
      border-radius 4px
      position relative
      &:hover
        .hover
          display block
      img
        width 100%
        height 118px
        margin 0 auto
        display block
      .hover
        position absolute
        top 0
        width 100%
        background rgba(0, 0, 0, 0.5)
        height 118px
        margin 0 auto
        display none
        .icon
          position absolute
          width 60%
          height 100%
          left 0
          right 0
          top 0
          bottom 0
          margin auto
          text-align center
          .create
            color #fff
            width 48px
            height 48px
            line-height 48px
            border-radius 8px
            background #000
            opacity 0.5
            top 36px
            text-align center
            font-size 18px
            cursor pointer
            position absolute
          .trash
            color #fff
            cursor pointer
            width 48px
            height 48px
            line-height 48px
            position absolute
            right 0
            border-radius 8px
            background #000
            opacity 0.5
            top 36px
            text-align center
            font-size 18px
          .ivu-icon
            color #fff
            font-size 22px
      .Horizontal-line
        background #dddddd
        height 1px
        margin-top 20px
      .circle
        width 8px
        height 8px
        background rgba(120, 203, 29, 1)
        border-radius 4px
        margin-right 4px
      .publish
        margin-right 4px
        font-size 12px
        font-family MicrosoftYaHeiUI
        color rgba(42, 46, 54, 0.8)
        line-height 15px
      .label-ul
        display flex
        justify-content flex-start
        margin-top 8px
        .Label
          width 58px
          margin-left 8px
          height 22px
          background rgba(60, 118, 208, 0.1)
          border-radius 2px
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(56, 133, 225, 1)
          text-align center
          overflow hidden
          text-overflow ellipsis
          &:first-child
            margin-left 0px
      .teach-case-content-t
        margin 12px
        position relative
        .case-title
          font-size 14px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 1)
          line-height 21px
          // display -webkit-box
          min-height 41px
          // overflow hidden
          // white-space normal !important
          // text-overflow ellipsis
          // word-wrap break-word
          // -webkit-line-clamp 2
          // -webkit-box-orient vertical
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
        .time
          font-size 12px
          font-family MicrosoftYaHeiUI
          color rgba(42, 46, 54, 0.75)
          line-height 15px
          margin-top 9px
          display inline-block
        .menu
          height 25px
          width 25px
          position absolute
          bottom -2px
          right -6px
          &:hover
            .edit-menu
              display block
        .edit-menu
          top 0px
          position absolute
          right 16px
          width 80px
          background rgba(255, 255, 255, 1)
          box-shadow 0px 0px 6px 0px rgba(0, 0, 0, 0.2)
          border-radius 4px
          z-index 100
          padding 4px 0
          display none
          list-style none
          text-align left
          li
            width 80px
            height 36px
            border-bottom 1px solid #eee
            font-size 14px
            font-family MicrosoftYaHeiUI
            color rgba(42, 46, 54, 0.8)
            line-height 36px
            padding-left 16px
            cursor pointer
            &:hover
              background rgba(245, 245, 245, 1)
              color #2D8CF0
    .add-case
      width 210px
      height 253px
      background #fff
      margin 7px
      vertical-align top
      border-radius 4px
      cursor pointer
      position relative
      img
        width 90px
        height 94px
        margin 40px auto
        display block
      span
        color grey
        position absolute
        bottom 40px
        width 100%
        text-align center
.dot
  width 8px
  height 8px
  line-height 8px
  border-radius 50%
  background gray
  margin-right 8px
  margin-left 4px
  display inline-block
.dotactive
  background #78cb1d
.addTeacherstitle
  text-align right
  vertical-align middle
  text-align left
  font-size 14px
  color #515a6e
  line-height 1
  padding 10px 12px 16px 0
  -webkit-box-sizing border-box
  box-sizing border-box
.addTeachers
  width 488px
  border 1px solid #dcdee2
  border-radius 4px
  position relative
  z-index 1053
  // 这里是外框的上半部分
  .inputBlock
    .tagBox
      min-height 32px
      padding 0 24px 0 4px
      display block
      cursor pointer
      div
        position: relative;
        .noSelect
          display block
          height 30px
          line-height 30px
          color #c5c8ce
          font-size 14px
          overflow hidden
          text-overflow ellipsis
          white-space nowrap
          padding-left 4px
          padding-right 22px
        .selectSearch
          border none
          // background: red
          width 100%
          height 32px
          display inline-block
          &:focus
            outline none // border
    .openDown
      position absolute
      top 50%
      right 8px
      line-height 1
      -webkit-transform translateY(-50%)
      transform translateY(-50%)
      font-size 14px
      color #808695
      -webkit-transition all 0.2s ease-in-out
      transition all 0.2s ease-in-out
      cursor pointer
  // 这里是选择教师部分
  .teachersList
    position absolute !important
    min-width 488px
    width inherit
    max-height 200px
    overflow auto
    margin 5px 0
    padding 5px 0
    background-color #fff
    -webkit-box-sizing border-box
    box-sizing border-box
    border-radius 4px
    -webkit-box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
    box-shadow 0 1px 6px rgba(0, 0, 0, 0.2)
    position absolute
    z-index 900
    .dropDownList
      min-width 100%
      list-style none
      box-sizing border-box
      margin 0
      padding 0
      -webkit-tap-highlight-color rgba(0, 0, 0, 0)
      .listChild
        position relative
        margin 0
        line-height normal
        padding 7px 16px
        clear both
        color #515a6e
        font-size 14px !important
        white-space nowrap
        list-style none
        cursor pointer
        -webkit-transition background 0.2s ease-in-out
        transition background 0.2s ease-in-out
        .ivu-icon-md-checkmark
          float right
          display none
      .listChild:hover
        background #F3F3F3
      .checkThisTeacher
        color rgba(45, 140, 240, 0.9)
        display initial !important
.mask
  position fixed
  overflow auto
  top 0
  right 0
  bottom 0
  left 0
  z-index 1052
  outline 0
</style>
